import { createReducer } from '@reduxjs/toolkit';
var initialState = {
    loading: {},
    dragging: null,
    components: {
        sidebarIsVisible: false,
    },
};
export default createReducer(initialState, {
    // LOADING EVENTS
    'app/startLoading': function () { },
    'app/resolveLoading': function () { },
    'user/invites/check/pending': function (state) {
        state.loading['user/invites/check'] = true;
    },
    'user/invites/check/fulfilled': function (state) {
        state.loading['user/invites/check'] = false;
    },
    'collection/load/pending': function (state) {
        state.loading['collection/create'] = true;
    },
    'collection/create/pending': function (state) {
        state.loading['collection/create'] = true;
    },
    'collection/load/fulfilled': function (state) {
        state.loading['collection/create'] = false;
    },
    'collection/create/fulfilled': function (state) {
        state.loading['collection/create'] = false;
    },
    'collection/load/rejected': function (state) {
        state.loading['collection/create'] = false;
    },
    'collection/create/rejected': function (state) {
        state.loading['collection/create'] = false;
    },
    // OTHER EVENTS
    'app/toggleNavbar': function (state, action) {
        state.components.sidebarIsVisible =
            action.payload !== undefined
                ? action.payload
                : !state.components.sidebarIsVisible;
    },
    'app/startDragEvent': function (state, action) {
        state.dragging = action.payload.fileType;
    },
    'app/resolveDragEvent': function (state) {
        state.dragging = null;
    },
});
// export default (
// 	state = INITIAL_STATE,
// 	action: { type: string; payload?: any }
// ) => {
// 	switch (action.type) {
// 		case 'START_LOADING':
// 			return {
// 				...state,
// 				loading: {
// 					...state.loading,
// 					[action.payload.loadingElem]: {
// 						...state.loading[action.payload.loadingElem],
// 						[action.payload.pendingAction]: true,
// 						// the boolean in the line above is not necessary
// 						// (the action's name as object key is enough)
// 					},
// 				},
// 			}
// 		case 'RESOLVE_LOADING':
// 			const { [action.payload.resolvedAction]: resolved, ...loading } =
// 				state.loading[action.payload.loadingElem]
// 			return {
// 				...state,
// 				loading: { ...state.loading, [action.payload.loadingElem]: loading },
// 			}
// 		case 'DRAG_STARTED':
// 			return {
// 				...state,
// 				dragging: action.payload.fileType,
// 			}
// 		case 'DRAG_ENDED':
// 			return {
// 				...state,
// 				dragging: null,
// 			}
// 		default:
// 			return state
// 	}
// }
